module.exports = "./img/be9c0c77f5601035ade99274fca3f886.jpg";